/**
 * External Imports
 */
import { FC, useCallback } from 'react';
import { connect } from 'react-redux';

/**
 * Internal Imports
 */
import SupportListSettingsTable from './supportListSettingsTable/SupportListSettingsTable';
import { RootState } from '../../../../redux/store';
import {
  useGetEmployeeSubjectConfigQuery,
  useUpdateSubjectHiddenStatusMutation
} from '../../../../redux/apis/Users.api';

import { useFeatures } from '../../../../services/Features/features';
import { useUserRolesRef } from '../../../../services/UserRoles';

/**
 * GLobal Type Definition Imports
 */
import { ValidationEmployee } from '../../../../config/interfaces';

interface BSSRListSettingsProps {
  facilityId: string;
  userId: string;
}

const BSSRListSettingsTable: FC<BSSRListSettingsProps> = ({
  facilityId,
  userId
}) => {
  const {
    isEnterpriseAdmin,
    isNonSupportRounder,
    isTemplateConfigurator,
    isUserAdmin,
    isBssrValidationRounder
  } = useUserRolesRef();

  const { isBSSRValidationEnabled } = useFeatures();

  const {
    data: bssrValidationEmployeeData,
    // isError: isGetEmployeeSubjectConfigError,
    // isFetching: isGetEmployeeSubjectConfigFetching,
    isLoading: isGetEmployeeSubjectConfigLoading
  } = useGetEmployeeSubjectConfigQuery(
    // Need to adjust later when we know new validation rounding types
    { employeeId: userId, roundingType: 'bssrValidation' },
    {
      refetchOnMountOrArgChange: 15,
      skip: !isBSSRValidationEnabled || !userId
    }
  );
  const [
    updateSubjectHiddenStatus
    // {
    //   isError: isUpdateSubjectHiddenStatusError,
    //   isLoading: isUpdateSubjectHiddenStatusLoading,
    //   isSuccess: isUpdateSubjectHiddenStatusSuccess
    // }
  ] = useUpdateSubjectHiddenStatusMutation();

  const hideEmployee = useCallback(
    (employee: ValidationEmployee) => {
      updateSubjectHiddenStatus({
        employeeId: employee.hcaid,
        facilityId,
        roundingType: 'bssrValidation',
        userId,
        visible: !employee.visible
      });
    },
    [facilityId, userId]
  );

  return (
    <SupportListSettingsTable
      employees={bssrValidationEmployeeData}
      isFacilitySelectorEnabled={
        isEnterpriseAdmin ||
        (isBssrValidationRounder &&
          !(isNonSupportRounder || isTemplateConfigurator || isUserAdmin))
      }
      isTableEnabled={isBSSRValidationEnabled}
      loadingSupportList={isGetEmployeeSubjectConfigLoading}
      type="bssr"
      hideEmployee={hideEmployee}
    />
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    facilityId: state.AuthorizedUser.authorizedUser.facilityId,
    userId: state.AuthorizedUser.authorizedUser.hcaid
  };
};

export default connect(mapReduxStateToProps)(BSSRListSettingsTable);
